module.exports = __webpack_public_path__ + "media/images/oyako_logo-f5a2efc04c99d035448979d65cc9ce2c.png";